import axios, { AxiosInstance, AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import * as Sentry from '@sentry/nextjs';

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  Sentry.captureException(error);
  return Promise.reject(error);
};

/**
 * http response가 then으로 넘어가기전 call
 */
const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};
/**
 * http response가 catch로 넘어가기전 call
 */
const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (axios.isAxiosError(error)) {
    const { code } = error;
    Sentry.captureException(error);
    if (code === 'ECONNABORTED') {
      alert('네트워크 연결이 불안정합니다. 다시 시도하거나 인터넷 연결을 확인해 주세요.');
    }
    if (code === 'ETIMEDOUT') {
      alert('요청 시간이 초과되었습니다. 다시 시도해 주세요.');
    }
    if (code === 'ECONNREFUSED') {
      alert('서버와 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.');
    }
    if (code === 'ENOTFOUND') {
      alert(
        '요청한 서비스를 찾을 수 없습니다. 호스트명이 올바른지 확인하고 네트워크 연결을 확인해주세요.',
      );
    }
  } else {
    console.error(error);
  }
  return Promise.reject(error);
};

const setInterceptors = (axiosInstance: AxiosInstance): AxiosInstance => {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
};

export default setInterceptors;
